import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// 获取机器人日志
export const getlogs = (params: any) => {
	return https().request(`log/robot`, Method.GET, params, ContentType.form)
}
// 获取机器人最新一条日志记录结果
export const lastlogs = (params: any) => {
	return https().request(`log/last`, Method.GET, params, ContentType.form)
}
// 取消下载日志
export const cancellogs = (params: any) => {
	return https().request(`log/cancel`, Method.POST, params, ContentType.json)
}